export default "__VITE_ASSET__DaieZKuW__"